import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { TravelinfoService } from 'src/services/travelinfo.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-travel-advisory',
  templateUrl: './travel-advisory.component.html',
  styleUrls: ['./travel-advisory.component.scss'],
})
export class TravelAdvisoryComponent implements OnInit {
  selectedPage: any;
  images: any = [];
  public travelInfoData: any = { bannerImage: null, bannerTitle: null };
  public travelInfoDataNew: any = { bannerContent: null };
  public showGalleryItemPopup = false;
  public selectedGalleryItem: any = null;
  activeIndex: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  constructor(private travelinfoService: TravelinfoService, private titleService: Title, private meta: Meta) {}

  ngOnInit(): void {
    this.meta.updateTag({
      name: 'description',
      content:
        'Stay Informed with Seychelles Travel Advisory - Your Essential Guide for Safe and Enjoyable Island Exploration.',
    });
    this.getDetails();
  }

  getDetails() {
    this.travelinfoService.getTravelAdvisoryDetails().subscribe((travelInfo) => {
      if (travelInfo) {
        this.travelInfoData = travelInfo;
        this.titleService.setTitle(this.travelInfoData.bannerTitle + ' ' + '| The Seychelles Islands');
      }
    });
    this.travelinfoService.getTravelAdvisoryDetailsNew().subscribe((travelInfoNew) => {
      if (travelInfoNew) {
        this.travelInfoDataNew = travelInfoNew;
        this.images.push(this.travelInfoDataNew.bannerImage);
        this.travelinfoService.getTravelDetails().subscribe((travelInfo) => {
          this.travelInfoDataNew.travelGallery = [];
          this.travelInfoDataNew.travelGallery2 = [];
          for (var i = 0; i < travelInfo.results.length; i++) {
            // let imgurl = environment.BaseURL.toLowerCase() + '/' + travelInfo.results[i].field_image;
            let imgurl = travelInfo.results[i].field_image;
            var json = {
              gridPopupTitle: travelInfo.results[i].field_popup_title.replace('&#039;', "'"),
              gridTitle: travelInfo.results[i].title.replace('&#039;', "'"),
              url: imgurl,
              gridPopupDescription: travelInfo.results[i].body.replace('&#039;', "'"),
            };
            if (i <= 5) {
              this.travelInfoDataNew.travelGallery.push(json);
            } else {
              this.travelInfoDataNew.travelGallery2.push(json);
            }
          }
        });
      }
    });
  }

  openGalleryItemPopup(item: any) {
    this.showGalleryItemPopup = true;
    this.selectedGalleryItem = item;
  }

  closeGalleryItemPopup() {
    this.showGalleryItemPopup = false;
    this.selectedGalleryItem = null;
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
